import styled from "styled-components";

export const MenuList = styled.li`
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: 6px;
`;

export const MenuCategory = styled.div`
  padding: 0px 12px;
  color: #b4b4bf;
  font-size: 1.2rem;
  font-weight: 700;
`;

export const MenuItemList = styled.ul`
  display: flex;
  flex-direction: column;
`;
